import React, { Fragment } from "react";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme();

export default function BuscaForm(props) {
  return <ThemeProvider theme={theme}>
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <TextField
            required
            id="rut"
            label="Ingresa tu rut"
            helperText="Sin punto ni guíon y con digito verificador. Ejemplo: 123456789"
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            onChange={props.leerRut}
            variant="outlined"
            inputProps={{
              style: { fontSize: 20 }
            }}
          />
        </Grid>
      </Grid>
    </Fragment>
    </ThemeProvider>;
}